import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingRoutingModule, COMPONENTS } from './landing-routing.module';
import { LandingComponent } from './landing.component';
import { ThemeModule } from '@theme/theme.module';
import { SwiperModule } from 'swiper/angular';
import { LandingArtworksComponent } from './components/artworks/artworks.component';

@NgModule({
  declarations: [
    LandingComponent,
    LandingArtworksComponent,
    ...COMPONENTS,
  ],
  imports: [
    CommonModule,
    LandingRoutingModule,
    ThemeModule,
    SwiperModule,
  ],
})
export class LandingModule { }
